module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-bumper_selected.de9f12f2.svg";